// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container-wrapper {
	position: relative;
	width: 100%;
	height: 75%;
}

.rectangle {
	animation: appear 0.2s ease-in-out;
}
.leaflet-container {
	font-family: "Helvetica Neue", Arial, Helvetica, sans-serif;
	font-size: 12px;
	font-size: 0.75rem;
	line-height: 1.5;
}

.leaflet-container {
	background: #ddd;
	outline-offset: 1px;
}
.leaflet-container {
	-webkit-tap-highlight-color: transparent;
}
.mymap-circular-progress {
	position: absolute;
	left: 90px;
	top: 60px;
	z-index: 1000;
}
.leaflet-container {
	overflow: hidden;
}
.leaflet-pane,
.leaflet-tile,
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-tile-container,
.leaflet-pane > svg,
.leaflet-pane > canvas,
.leaflet-zoom-box,
.leaflet-image-layer,
.leaflet-layer {
	position: absolute;
	left: 0;
	top: 0;
}

.leaflet-layer {
	filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3));
}

.map-container-wrapper.leaflet-pane.leaflet-overlay-pane
	g
	path.leaflet-interactive {
	stroke: red;
	stroke-opacity: 1;
	stroke-width: 3;
	stroke-linecap: round;
	stroke-linejoin: round;
	fill: red;
	fill-opacity: 0.2;
	fill-rule: evenodd;
	/* z-index: 5000; */
	/* d: path("M 146 132 L 146 104 L 169 104 L 169 132 Z"); */
}

.leaflet-pane > svg path.leaflet-interactive {
	pointer-events: auto;
}
.leaflet-pane {
	z-index: 401;
}

.leaflet-marker-icon.leaflet-interactive,
.leaflet-image-layer.leaflet-interactive,
.leaflet-pane > svg path.leaflet-interactive,
svg.leaflet-image-layer.leaflet-interactive path {
	pointer-events: visiblePainted;
	pointer-events: auto;
}

.leaflet-marker-icon.leaflet-interactive,
.leaflet-image-layer.leaflet-interactive,
.leaflet-pane > svg path.leaflet-interactive,
svg.leaflet-image-layer.mymap-indicator.leaflet-interactive path {
	pointer-events: none;
}

#map {
	height: 180px;
}

.leaflet-tile-container
	.leaflet-tile.leaflet-tile-loaded
	.leaflet-layer:not(.leaflet-marker-icon):not(.leaflet-control) {
	fill: black !important;
	stroke: black !important;
}

.leaflet-container {
	width: 100%;
	object-fit: contain;
	padding-top: 75%; /* Aspect ratio of 4:3 (divide 3 by 4 = 0.75) */
	border-radius: 0.7rem;
}

.layover {
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 5000;
	opacity: 1;
	right: 0px;
	bottom: 0px;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	/* margin: 1rem 1rem; */
}

@keyframes appear {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 100;
	}
}

@keyframes slide-left {
	0% {
		transform: scaleX(0);
		opacity: 0;
	}
	100% {
		transform: scaleX(1);
		opacity: 100;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/MapWithDate/MyMap/MyMap.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,kCAAkC;AACnC;AACA;CACC,2DAA2D;CAC3D,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,wCAAwC;AACzC;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;;;;;;;;;;CAUC,kBAAkB;CAClB,OAAO;CACP,MAAM;AACP;;AAEA;CACC,mDAAmD;AACpD;;AAEA;;;CAGC,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,sBAAsB;CACtB,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,0DAA0D;AAC3D;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,YAAY;AACb;;AAEA;;;;CAIC,8BAA8B;CAC9B,oBAAoB;AACrB;;AAEA;;;;CAIC,oBAAoB;AACrB;;AAEA;CACC,aAAa;AACd;;AAEA;;;CAGC,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,gBAAgB,EAAE,+CAA+C;CACjE,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,aAAa;CACb,UAAU;CACV,UAAU;CACV,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,UAAU;CACX;CACA;EACC,oBAAoB;EACpB,YAAY;CACb;AACD","sourcesContent":[".map-container-wrapper {\n\tposition: relative;\n\twidth: 100%;\n\theight: 75%;\n}\n\n.rectangle {\n\tanimation: appear 0.2s ease-in-out;\n}\n.leaflet-container {\n\tfont-family: \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n\tfont-size: 12px;\n\tfont-size: 0.75rem;\n\tline-height: 1.5;\n}\n\n.leaflet-container {\n\tbackground: #ddd;\n\toutline-offset: 1px;\n}\n.leaflet-container {\n\t-webkit-tap-highlight-color: transparent;\n}\n.mymap-circular-progress {\n\tposition: absolute;\n\tleft: 90px;\n\ttop: 60px;\n\tz-index: 1000;\n}\n.leaflet-container {\n\toverflow: hidden;\n}\n.leaflet-pane,\n.leaflet-tile,\n.leaflet-marker-icon,\n.leaflet-marker-shadow,\n.leaflet-tile-container,\n.leaflet-pane > svg,\n.leaflet-pane > canvas,\n.leaflet-zoom-box,\n.leaflet-image-layer,\n.leaflet-layer {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n}\n\n.leaflet-layer {\n\tfilter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3));\n}\n\n.map-container-wrapper.leaflet-pane.leaflet-overlay-pane\n\tg\n\tpath.leaflet-interactive {\n\tstroke: red;\n\tstroke-opacity: 1;\n\tstroke-width: 3;\n\tstroke-linecap: round;\n\tstroke-linejoin: round;\n\tfill: red;\n\tfill-opacity: 0.2;\n\tfill-rule: evenodd;\n\t/* z-index: 5000; */\n\t/* d: path(\"M 146 132 L 146 104 L 169 104 L 169 132 Z\"); */\n}\n\n.leaflet-pane > svg path.leaflet-interactive {\n\tpointer-events: auto;\n}\n.leaflet-pane {\n\tz-index: 401;\n}\n\n.leaflet-marker-icon.leaflet-interactive,\n.leaflet-image-layer.leaflet-interactive,\n.leaflet-pane > svg path.leaflet-interactive,\nsvg.leaflet-image-layer.leaflet-interactive path {\n\tpointer-events: visiblePainted;\n\tpointer-events: auto;\n}\n\n.leaflet-marker-icon.leaflet-interactive,\n.leaflet-image-layer.leaflet-interactive,\n.leaflet-pane > svg path.leaflet-interactive,\nsvg.leaflet-image-layer.mymap-indicator.leaflet-interactive path {\n\tpointer-events: none;\n}\n\n#map {\n\theight: 180px;\n}\n\n.leaflet-tile-container\n\t.leaflet-tile.leaflet-tile-loaded\n\t.leaflet-layer:not(.leaflet-marker-icon):not(.leaflet-control) {\n\tfill: black !important;\n\tstroke: black !important;\n}\n\n.leaflet-container {\n\twidth: 100%;\n\tobject-fit: contain;\n\tpadding-top: 75%; /* Aspect ratio of 4:3 (divide 3 by 4 = 0.75) */\n\tborder-radius: 0.7rem;\n}\n\n.layover {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 5000;\n\topacity: 1;\n\tright: 0px;\n\tbottom: 0px;\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\t/* margin: 1rem 1rem; */\n}\n\n@keyframes appear {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 100;\n\t}\n}\n\n@keyframes slide-left {\n\t0% {\n\t\ttransform: scaleX(0);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\ttransform: scaleX(1);\n\t\topacity: 100;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
